import AdminLoginForm from "../../components/AdminPortal/AdminLogin/AdminLoginForm";
import learningportalimg from "../../assets/images/learningportal.svg";
import { useEffect } from "react";
export default function AdminLogin() {
  useEffect(() => {
    document.title = "Admin Login - LWS Learning Portal";
  }, []);
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img
            className="h-12 mx-auto"
            src={learningportalimg}
            alt="Learning Portal"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Sign in to Admin Account
          </h2>
        </div>
        <AdminLoginForm />
      </div>
    </section>
  );
}
